<script lang="ts">
	import { menuOpen } from '$lib/stores/ui-store';

	export let floatingPosition: boolean;
</script>

{#if $menuOpen && !floatingPosition}
	<button class="h-12 w-[46px] pointer-events-none opacity-0 mt-4" aria-label="Lukk meny"></button>
{/if}
<div class="w-[118px] lg:w-[125px]">
	<button
		class="btn px-4 py-3 !rounded-full gap-x-2 text-secondary duration-150 border-2 lg:hover:text-primary
		{floatingPosition
			? 'absolute top-3 left-[1%] !z-60 flex'
			: 'w-auto basis-[46px] self-start my-2 ml-4 shadow-none'} 
		{$menuOpen ? 'hidden' : '!bg-white !border-transparent'}"
		aria-label={$menuOpen ? 'Lukk meny' : 'Åpne meny'}
		on:click={() => ($menuOpen = !$menuOpen)}
	>
		<svg class="stroke-secondary" width="24" height="24">
			<line id="top" x1="0" y1="4" x2="24" y2="4" />
			<line id="middle" x1="0" y1="12" x2="24" y2="12" />
			<line id="bottom" x1="0" y1="20" x2="24" y2="20" />
		</svg>
		<span class="font-medium {$menuOpen ? 'hidden' : ''}">Meny</span>
	</button>
</div>
